<template>
    <component :is="currentDialog">
    </component>
</template>



<script>

import { ref, watch, computed, provide } from 'vue';
import { UserActivityStore } from '@/store/UserActivityStore';
import DialogFactory from '@/utils/ComponentFactory/DialogFactory';

export default {
    name: 'EarnDialogs',
    setup() {
        const inHouseTaskStore = UserActivityStore();
        const inHouseTaskOpenDialog = ref(false);
        provide('inHouseTaskOpenDialog', inHouseTaskOpenDialog);

        const selectedInHouseTask = computed(() => inHouseTaskStore.selectedInHouseTask);

        watch(selectedInHouseTask, () => {
            inHouseTaskOpenDialog.value = true;
        });
        const currentDialog = computed(() => {
            if (selectedInHouseTask.value) {
                return DialogFactory.getDialog(selectedInHouseTask.value.name);
            }
            return null;
        });

        // Expose the properties and methods to the template
        return {
            currentDialog,
        };
    },
};
</script>